import { ISearchParams, SearchService } from './SearchService';
const mapServiceType: Map<string, string> = new Map([
	['Aged Care', 'service_type service_type--aged_care'],
	['NDIS & Disability', 'service_type service_type--ndis'],
	['LiveBetter News', 'service_type service_type--none'],
	['Other Services', 'service_type service_type--other'],
	['Volunteers', 'service_type service_type--none'],
	['Work With Us', 'service_type service_type--none'],
]);

export class FacetList<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;
	protected _defaultSearch: ISearchParams<TFacets>;
	protected _ignoreFacets: TFacets[];
	protected _prependElement: string | undefined;

	constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		ignoreFacets: TFacets[] = [],
		prependElement?: string,
	) {
		this._element = element;
		this._searchService = searchService;
		this._defaultSearch = searchService.defaultSearch;
		this._ignoreFacets = ignoreFacets;
		this._prependElement = prependElement;

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		const userFacets = this._searchService.getUserFacets();
		const pills: JQuery<HTMLElement>[] = [];
		let pillContainer: string | JQuery<HTMLElement> = '';

		const clear = $(
			`<button class="search_pill-clear-all-btn">
				<span>Clear all</span>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
				</svg>
			</button>`,
		).on('click', () => {
			this.handleClearAll();
		});

		if (userFacets.length) {
			userFacets.forEach((facet) => {
				// Skip the facets to ignore
				if (
					this._ignoreFacets.indexOf(facet.facetName as TFacets) >= 0
				) {
					return;
				}
				facet.facetValue.forEach((value) => {
					const serviceType = findServiceType(value);

					const pill = $(`
						<button class="search_pill ${serviceType}">
							<span class="search_pill-text">${value}</span>
							<span class="search_pill-svg-icon">
								<svg
									class=""
									xmlns="http://www.w3.org/2000/svg"
									width="8px" 
									height="8px" viewBox="0 0 5 5"><path d="M5 .503L4.497 0 2.5 1.996.503 0 0 .503 1.996 2.5 0 4.497.503 5 2.5 3.003 4.497 5 5 4.497 3.003 2.5z" fill="currentColor" fill-rule="nonzero"/></svg>
							</span>
						</button>
					`);

					pill.on('click', () => {
						// Remove the facet
						const updatedSearchParams =
							this._searchService.searchParams;

						updatedSearchParams.facetsData[facet.facetName] = (
							updatedSearchParams.facetsData[
								facet.facetName
							] as string[]
						).filter((item) => {
							return item !== value;
						});

						if (
							!updatedSearchParams.facetsData[facet.facetName]
								.length
						) {
							updatedSearchParams.facetsData[facet.facetName] =
								[];
						}
						this._searchService.searchParams = updatedSearchParams;
					});

					pills.push(pill);
				});
			});
		}

		if (pills.length) {
			pillContainer = $(
				`<div class="flex text-small leading-5 items-center">
					${this._prependElement ? this._prependElement : ''}
					<div class="search-pills-facets-container" data-facets-container></div>
				</div>`,
			);
			$('[data-facets-container]', pillContainer).append(...pills);
			$('[data-facets-container]', pillContainer).append(clear);
		}

		this._element.empty().append(pillContainer);
	}

	protected handleClearAll() {
		const updatedSearchParams = this._searchService.searchParams;
		updatedSearchParams.facetsData = this._defaultSearch.facetsData;
		this._searchService.searchParams = updatedSearchParams;
	}
}
function findServiceType(name: string) {
	if (mapServiceType.has(name)) {
		return mapServiceType.get(name);
	} else {
		return 'service_type service_type--other';
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetsList.ts